/*
Author: Jude Fernando
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

const NumberInput = (props:any) => {
    const {node, name, children} = props;
    return (
        <div>
            <label>{node.title}</label>
            <input className="border" type="number" name={name} />
            <div>{children}</div>
        </div>
    )
}

export default NumberInput;